import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faFacebookF} from '@fortawesome/free-brands-svg-icons'

import type {SizeProp} from '@fortawesome/fontawesome-svg-core'

interface FaFacebookProps {
  text?: string
  textIsBefore?: boolean
  showIconText?: boolean
  size?: SizeProp
}

const FaFacebook = ({
  text,
  textIsBefore = false,
  showIconText = false,
  size = 'sm',
}: FaFacebookProps) => {
  let renderDOM = (
    <span className='icon'>
      <FontAwesomeIcon icon={faFacebookF} size={size} />
    </span>
  )
  if (text) {
    renderDOM = (
      <span
        className='icon-text'
        style={{flexWrap: 'nowrap'}}
      >
        {textIsBefore && showIconText && <span>{text}</span>}
        <span className='icon'>
          <FontAwesomeIcon icon={faFacebookF} size={size} />
        </span>
        {!textIsBefore && showIconText && <span>{text}</span>}
      </span>
    )
  }
  return renderDOM
}

export default FaFacebook
